module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch0005_Acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")]), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch0006_Introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01_partone#partone"
    }
  }, [_vm._v("PART 1   GANGS: NOW AND THEN")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1. The Current Gang Problem")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Gangs in the Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03_parttwo#parttwo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2   THE CONTEMPORARY GANG")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Gang Characteristics")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Black and Chicano Gangs: In and Out of Prison")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Why Gangs Kill: The Sociopath Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06_partthree#partthree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3   TREATMENT APPROACHES")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Some Effective Interventions")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Therapeutic Community Approach to Gangs")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_partfour#partfour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 4   GANG THEORIES AND TREATMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Varied Theoretical Viewpoints")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Violent Gang as a Near-Group")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Joining a Positive Gang: A Plan for Treating Gangsters in a Therapeutic Community.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11_notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")]), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028c4a78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00-04_content.vue
// module id = 69
// module chunks = 0